import * as React from "react";
import type { IDropdownChild } from "@similarweb/ui-components";
import { Dropdown } from "@similarweb/ui-components";

interface MultiSelectDropdownContainerProps {
    initialSelection: object;
    children: IDropdownChild[];
    onItemClick: (id) => void;
    disabled?: boolean;
    onToggle?: (isOpen: boolean) => void;
}

export class MultiSelectDropdownContainer extends React.PureComponent<MultiSelectDropdownContainerProps, any> {
    public static getDerivedStateFromProps(props, state) {
        if (state.selectedIds !== props.initialSelection) {
            return {
                selectedIds: props.initialSelection,
            };
        }

        return null;
    }

    constructor(props) {
        super(props);
        this.state = {
            selectedIds: props.initialSelection,
        };
    }

    public onClick = (newItem) => {
        const newState = {
            selectedIds: {
                ...this.state.selectedIds,
                [newItem.id]: !this.state.selectedIds[newItem.id],
            },
        };
        this.setState(newState);
        this.props.onItemClick(newState.selectedIds);
    };

    public render() {
        return (
            <Dropdown
                selectedIds={this.state.selectedIds}
                onClick={this.onClick}
                closeOnItemClick={false}
                {...this.props}
            >
                {this.props.children}
            </Dropdown>
        );
    }
}
